<div class="admin-layout">
  <!-- Offcanvas Backdrop -->
  @if (sidebarOpen()) {
    <div class="offcanvas-backdrop" (click)="closeSidebar.emit()"></div>
  }

  <!-- Offcanvas Sidebar Drawer -->
  <aside class="offcanvas-sidebar" [class.open]="sidebarOpen()">
    <div class="offcanvas-header">
      <a routerLink="/secure/admin" class="logo-link">
        <img src="/assets/images/logo2.png" alt="Logo" class="logo-img"/>
        <div class="logo-text-block">
          <span class="logo-title">ACFS Supply Chain</span>
        </div>
      </a>
      <button class="close-btn" (click)="closeSidebar.emit()" aria-label="Close menu">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
             stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <nav class="offcanvas-nav">
      <a class="nav-item" (click)="goToPortalSystem.emit(); closeSidebar.emit()">
        <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
          <polyline points="15 3 21 3 21 9"/>
          <line x1="10" y1="14" x2="21" y2="3"/>
        </svg>
        <span>กลับไปที่ e-Portal</span>
      </a>

      <div class="nav-divider"></div>

      @if (canSeeDashboard()) {
        <a class="nav-item" routerLink="/admin/dashboard" routerLinkActive="active" (click)="closeSidebar.emit()">
          <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="7" height="7" rx="1"/>
            <rect x="14" y="3" width="7" height="7" rx="1"/>
            <rect x="14" y="14" width="7" height="7" rx="1"/>
            <rect x="3" y="14" width="7" height="7" rx="1"/>
          </svg>
          <span>หน้าหลัก</span>
        </a>
      }

      @if (canSeeProfile()) {
      <a class="nav-item" routerLink="/profile" routerLinkActive="active" (click)="closeSidebar.emit()">
        <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="8" r="4"/>
          <path d="M20 21a8 8 0 1 0-16 0"/>
        </svg>
        <span>โปรไฟล์</span>
      </a>
      }

      @if (canSeePurchaseSale() && !profileIncomplete()) {
        <a class="nav-item" routerLink="/trade" [class.active]="tradeMenuActive()" (click)="closeSidebar.emit()">
          <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
          <span>บันทึกซื้อ-ขาย</span>
        </a>
      }

      @if (canSeeObservations() && !profileIncomplete()) {
        <a class="nav-item" routerLink="/trade/observations" routerLinkActive="active" (click)="closeSidebar.emit()">
          <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <span>รายงานข้อสังเกต</span>
        </a>
      }

      @if (canSeeQrTrace() && !profileIncomplete()) {
        <a class="nav-item" routerLink="/qr-trace-confirm" routerLinkActive="active" (click)="closeSidebar.emit()">
          <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 11l3 3L22 4"/>
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
          </svg>
          <span>ยืนยันการจำหน่าย (QR Trace)</span>
        </a>
      }

      @if (canSeeChat() && !profileIncomplete()) {
        <a class="nav-item" routerLink="/chat" routerLinkActive="active" (click)="closeSidebar.emit()">
          <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
          <span>แชท</span>
          @if (chatUnreadCount() > 0) {
            <span class="nav-badge nav-badge-chat">{{ chatUnreadCount() }}</span>
          }
        </a>
      }

      @if (canSeeSurvey() && !profileIncomplete()) {
        <a class="nav-item" routerLink="/survey" routerLinkActive="active" (click)="closeSidebar.emit()">
          <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <span>แบบสอบถาม</span>
        </a>
      }

      @if (canSeeBusinessTypeSettings() && !profileIncomplete()) {
        <div class="nav-section-label">ผู้ดูแลระบบ</div>
        <a class="nav-item" routerLink="/admin/business-types" routerLinkActive="active" (click)="closeSidebar.emit()">
          <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
          <span>ตั้งค่าประเภทธุรกิจ</span>
        </a>
      }
    </nav>
  </aside>

  <!-- Main Content -->
  <div class="main-content">
    <header class="topbar">
      <div class="topbar-left">
        <button class="hamburger-btn" (click)="toggleSidebar.emit()" aria-label="Toggle sidebar">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </button>
        <a routerLink="/secure/admin" class="brand-text">ACFS Supply Chain</a>
      </div>

      <div class="topbar-right">
        <app-notification-bell></app-notification-bell>
        <div ngbDropdown class="dropdown user-dropdown" [autoClose]="true" placement="bottom-end">
          <div class="user-info-pill d-flex align-items-center gap-2 position-relative" ngbDropdownToggle
               role="button">
            <div class="user-text text-end d-none d-sm-block">
              <p class="mb-0 fw-bold user-name text-truncate">{{ userName() }}</p>
              @if (userRole()) {
                <p class="mb-0 user-type text-truncate">{{ userRole() }}</p>
              }
            </div>
            <div class="user-avatar-wrap">
              @if (userAvatar()) {
                <img [src]="userAvatar()" [alt]="userName() || 'รูปโปรไฟล์'" class="user-avatar-img" />
              } @else {
                <span class="user-avatar-placeholder">
                  <i class="bi bi-person-fill"></i>
                </span>
              }
            </div>
            <i class="bi bi-chevron-down chevron-down"></i>
          </div>

          <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end shadow border-0">
            <li class="dropdown-header px-3 py-2 border-bottom mb-1">
              <div class="d-flex align-items-center gap-2">
                <div class="user-avatar-wrap user-avatar-wrap-sm">
                  @if (userAvatar()) {
                    <img [src]="userAvatar()" [alt]="userName() || 'รูปโปรไฟล์'" class="user-avatar-img" />
                  } @else {
                    <span class="user-avatar-placeholder">
                      <i class="bi bi-person-fill"></i>
                    </span>
                  }
                </div>
                <div class="overflow-hidden">
                  <div class="fw-bold text-dark text-truncate">{{ userName() }}</div>
                  @if (userRole()) {
                    <div class="small text-muted text-truncate">{{ userRole() }}</div>
                  }
                  @if (userEmail()) {
                    <div class="small text-muted text-truncate">{{ userEmail() }}</div>
                  }
                </div>
              </div>
            </li>
            <li>
              <button ngbDropdownItem (click)="navigateToOidcAccountInfo.emit()"
                      class="d-flex align-items-center gap-2">
                <i class="bi bi-person-circle text-muted"></i>
                <span>Account Info</span>
              </button>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li>
              <a ngbDropdownItem routerLink="/profile/role-assign" routerLinkActive="active"
                 class="d-flex align-items-center gap-2" (click)="closeSidebar.emit()">
                <i class="bi bi-shield-check text-muted"></i>
                <span>มอบสิทธิ์ใช้งาน</span>
              </a>
            </li>
            <li>
              <a ngbDropdownItem routerLink="/profile/role-invitations" routerLinkActive="active"
                 class="d-flex align-items-center justify-content-between" (click)="closeSidebar.emit()">
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-envelope-check text-muted"></i>
                  <span>ตอบรับคำเชิญ</span>
                </div>
                @if (pendingInvitationCount() > 0) {
                  <span class="badge rounded-pill bg-danger">{{ pendingInvitationCount() }}</span>
                }
              </a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li>
              <button ngbDropdownItem (click)="logout.emit()" class="d-flex align-items-center gap-2 text-danger">
                <i class="bi bi-box-arrow-right"></i>
                <span>Log out</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
    <app-acting-as-banner></app-acting-as-banner>

    <main class="content-area" [class.content-area-full-screen]="fullScreenRoute()"
          [class.content-area-full-main]="fullMainRoute()">
      <app-toasts></app-toasts>
      <app-loading></app-loading>
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Bottom Nav -->
  @if (!fullScreenRoute()) {
    <nav class="bottom-nav" aria-label="Primary">
      @if (profileIncomplete()) {
        <a class="bottom-link" routerLink="/profile" routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: true }">
          <span class="nav-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                fill="currentColor"/>
            </svg>
          </span>
          <span class="nav-label">โปรไฟล์</span>
        </a>
      } @else {
    @if (canSeeDashboard()) {
        <a class="bottom-link" routerLink="/admin/dashboard" routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: true }">
          <span class="nav-icon">
            <svg width="22" height="22" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M56.87 25.981L50.27 21.031L47.27 18.781L35.57 10.001C34.4423 9.16327 33.0748 8.71094 31.67 8.71094C30.2652 8.71094 28.8977 9.16327 27.77 10.001L21.67 14.581V14.371C21.6684 13.8411 21.4572 13.3333 21.0825 12.9586C20.7077 12.5838 20.1999 12.3726 19.67 12.371H12.47C11.9396 12.371 11.4309 12.5817 11.0558 12.9568C10.6807 13.3319 10.47 13.8406 10.47 14.371V23.161L6.44002 26.291C6.23227 26.4524 6.05838 26.6531 5.92833 26.8817C5.79827 27.1103 5.71459 27.3624 5.68208 27.6234C5.64957 27.8844 5.66888 28.1493 5.73887 28.4028C5.80887 28.6564 5.92819 28.8936 6.09001 29.101C6.276 29.3427 6.51546 29.538 6.7896 29.6716C7.06373 29.8052 7.36505 29.8734 7.67 29.871C8.11211 29.8709 8.54152 29.7231 8.89 29.451L10.47 28.231V48.281C10.4716 50.0044 11.1569 51.6568 12.3756 52.8755C13.5942 54.0941 15.2466 54.7794 16.97 54.781H25.6C25.9594 54.7808 26.3121 54.6831 26.6203 54.4981C26.9285 54.3132 27.1807 54.0481 27.35 53.731C27.5142 53.4413 27.6003 53.114 27.6 52.781C27.6017 52.7109 27.5983 52.6407 27.59 52.571V46.851C27.5916 45.7703 28.0223 44.7345 28.7874 43.9713C29.5525 43.2081 30.5893 42.7799 31.67 42.781C32.7491 42.7821 33.7837 43.2112 34.5468 43.9742C35.3098 44.7373 35.7389 45.7719 35.74 46.851V52.781C35.7397 53.114 35.8259 53.4413 35.99 53.731C36.1624 54.0477 36.4167 54.3122 36.7263 54.4969C37.0359 54.6816 37.3895 54.7797 37.75 54.781H46.37C48.0929 54.7776 49.7442 54.0917 50.9624 52.8734C52.1807 51.6552 52.8666 50.0039 52.87 48.281V27.981L54.47 29.181C54.8129 29.4398 55.2305 29.5801 55.66 29.581C55.9718 29.5802 56.2792 29.5076 56.5584 29.3689C56.8376 29.2301 57.081 29.029 57.27 28.781C57.5883 28.3567 57.7249 27.8233 57.6499 27.2982C57.5749 26.7731 57.2944 26.2993 56.87 25.981Z"
                fill="currentColor"/>
            </svg>
          </span>
          <span class="nav-label">หน้าหลัก</span>
        </a>
      }
    @if (canSeePurchaseSale()) {
        <a class="bottom-link" routerLink="/trade" [class.active]="tradeMenuActive()">
          <span class="nav-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.5777 4.43152L15.5777 3.38197C13.8221 2.46066 12.9443 2 12 2C11.0557 2 10.1779 2.46066 8.42229 3.38197L8.10057 3.5508L17.0236 8.64967L21.0403 6.64132C20.3941 5.90949 19.3515 5.36234 17.5777 4.43152Z"
                fill="currentColor"/>
              <path
                d="M21.7484 7.96434L17.75 9.96353V13C17.75 13.4142 17.4142 13.75 17 13.75C16.5858 13.75 16.25 13.4142 16.25 13V10.7135L12.75 12.4635V21.904C13.4679 21.7252 14.2848 21.2965 15.5777 20.618L17.5777 19.5685C19.7294 18.4393 20.8052 17.8748 21.4026 16.8603C22 15.8458 22 14.5833 22 12.0585V11.9415C22 10.0489 22 8.86557 21.7484 7.96434Z"
                fill="currentColor"/>
              <path
                d="M11.25 21.904V12.4635L2.25164 7.96434C2 8.86557 2 10.0489 2 11.9415V12.0585C2 14.5833 2 15.8458 2.5974 16.8603C3.19479 17.8748 4.27062 18.4393 6.42228 19.5685L8.42229 20.618C9.71524 21.2965 10.5321 21.7252 11.25 21.904Z"
                fill="currentColor"/>
              <path
                d="M2.95969 6.64132L12 11.1615L15.4112 9.4559L6.52456 4.37785L6.42229 4.43152C4.64855 5.36234 3.6059 5.90949 2.95969 6.64132Z"
                fill="currentColor"/>
            </svg>
          </span>
          <span class="nav-label">ซื้อขาย</span>
        </a>
      }
        <a class="bottom-link is-primary" routerLink="/scan" routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-icon fab">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 class="lucide lucide-scan-qr-code-icon lucide-scan-qr-code">
              <path d="M17 12v4a1 1 0 0 1-1 1h-4"/>
              <path
                d="M17 3h2a2 2 0 0 1 2 2v2"/>
              <path d="M17 8V7"/>
              <path d="M21 17v2a2 2 0 0 1-2 2h-2"/>
              <path
                d="M3 7V5a2 2 0 0 1 2-2h2"/>
              <path d="M7 17h.01"/>
              <path d="M7 21H5a2 2 0 0 1-2-2v-2"/>
              <rect x="7" y="7" width="5"
                    height="5" rx="1"/>
            </svg>
          </div>
        </a>
    @if (canSeeChat()) {
        <a class="bottom-link" routerLink="/chat" routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: true }">
          <span class="nav-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7 10C7 9.44772 7.44772 9 8 9H8.01C8.56228 9 9.01 9.44772 9.01 10C9.01 10.5523 8.56228 11 8.01 11H8C7.44772 11 7 10.5523 7 10ZM11 10C11 9.44772 11.4477 9 12 9H12.01C12.5623 9 13.01 9.44772 13.01 10C13.01 10.5523 12.5623 11 12.01 11H12C11.4477 11 11 10.5523 11 10ZM16 9C15.4477 9 15 9.44772 15 10C15 10.5523 15.4477 11 16 11H16.01C16.5623 11 17.01 10.5523 17.01 10C17.01 9.44772 16.5623 9 16.01 9H16ZM6.93417 2C6.95604 2 6.97799 2 7 2L17.0658 2C17.9523 1.99995 18.7161 1.99991 19.3278 2.08215C19.9833 2.17028 20.6117 2.36902 21.1213 2.87868C21.631 3.38835 21.8297 4.0167 21.9179 4.67221C22.0001 5.28388 22.0001 6.0477 22 6.9342V13.0658C22.0001 13.9523 22.0001 14.7161 21.9179 15.3278C21.8297 15.9833 21.631 16.6117 21.1213 17.1213C20.6117 17.631 19.9833 17.8297 19.3278 17.9179C18.7161 18.0001 17.9523 18.0001 17.0658 18L14 18C13.8864 18 13.7757 18.036 13.6838 18.1028L9.27568 21.3087C8.32858 21.9975 7 21.321 7 20.1499V18C6.22604 18 5.44118 18.0213 4.67221 17.9179C4.0167 17.8297 3.38835 17.631 2.87868 17.1213C2.36902 16.6117 2.17028 15.9833 2.08215 15.3278C1.99991 14.7161 1.99995 13.9523 2 13.0658L2 7C2 6.97799 2 6.95604 2 6.93417C1.99995 6.04769 1.99991 5.28387 2.08215 4.67221C2.17028 4.0167 2.36902 3.38835 2.87868 2.87868C3.38835 2.36902 4.0167 2.17028 4.67221 2.08215C5.28387 1.99991 6.04769 1.99995 6.93417 2Z"
                fill="currentColor"/>
            </svg>
          </span>
          <span class="nav-label">แชท</span>
          @if (chatUnreadCount() > 0) {
            <span class="nav-badge-dot"></span>
          }
        </a>
      }
    @if (canSeeProfile()) {
        <a class="bottom-link" routerLink="/profile" routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: true }">
          <span class="nav-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                fill="currentColor"/>
            </svg>
          </span>
          <span class="nav-label">โปรไฟล์</span>
        </a>
      }
      }
    </nav>
  }
</div>
